/**
 * Shared card wrapper for individual conditions.
 * Matches PartConditionContainer from condition-editor-v2.
 */

import type { ReactNode } from 'react';
import { Box, Text } from '@customerio/pluma-components/react';
import type { ConditionNode } from '../types';
import { DataSourceIcon } from './data-source-icon';
import * as styles from './condition-card.css';

interface ConditionCardProps {
  node: ConditionNode;
  children: ReactNode;
}

export function ConditionCard({ node, children }: ConditionCardProps) {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap="100"
      p="100"
      w="full"
      overflowWrap="anywhere"
      className={styles.card}
    >
      <DataSourceIcon node={node} />
      <Text as="div" display="block" color="subtle" mt="025" className={styles.conditionText}>
        {children}
      </Text>
    </Box>
  );
}
